export namespace KommunikationEntityTypes {
    export const TROUBLE_TICKET_ENTITY = 'KOM.TT';
    export const ROLLE_ENTITY = 'KOM.ROLLE';
    export const MITTEILUNGS_VORLAGE_ENTITY = 'KOM.MTLGVORL';
    export const MITTEILUNG_ENTITY = 'KOM.MTLG';
    
}

